import { useState } from "react";
import { api } from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/errors";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Pencil } from "lucide-react";

// ID-050: edit product name / type / description (variants inherit name & type)
export function ProductEdit({ product, onSaved }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  const start = () => { setF({ name: product.name || "", product_type: product.product_type || "", description: product.description || "" }); setOpen(true); };
  const save = async (e) => {
    e.preventDefault();
    try { await api.patch(`/products/${product.id}`, f); toast.success("Product saved"); setOpen(false); onSaved?.(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  return (
    <>
      <Button size="sm" variant="outline" className="h-8 gap-1 text-xs" onClick={start} data-testid="product-edit-button"><Pencil className="h-3 w-3" /> Edit product</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="border-border bg-white sm:max-w-md" data-testid="product-edit-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl font-light text-charcoal">Edit product</DialogTitle></DialogHeader>
          <form onSubmit={save} className="space-y-4">
            <div><Label className="text-xs text-warmgrey">Name</Label><Input required value={f.name} onChange={set("name")} className="mt-1 h-10 bg-white" data-testid="product-edit-name" /></div>
            {product.design ? (
              <div><Label className="text-xs text-warmgrey">Classification</Label><p className="mt-1 text-sm text-charcoal" data-testid="product-edit-classification">Mosaic Collection ({product.design.category || "Mosaic"}) — material {product.product_type}</p></div>
            ) : (
              <div><Label className="text-xs text-warmgrey">Type</Label><Input required value={f.product_type} onChange={set("product_type")} className="mt-1 h-10 bg-white" data-testid="product-edit-type" /></div>
            )}
            <div><Label className="text-xs text-warmgrey">Description</Label><Textarea value={f.description} onChange={set("description")} className="mt-1 bg-white" data-testid="product-edit-description" /></div>
            <Button type="submit" className="w-full bg-terracotta text-white hover:bg-terracotta-hover" data-testid="product-edit-save">Save</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
